export default "__VITE_ASSET__C6slRHrO__"